import { render } from "./footer1.vue?vue&type=template&id=32b4a4e4&scoped=true"
const script = {}

import "./footer1.vue?vue&type=style&index=0&id=32b4a4e4&scoped=true&lang=css"

import exportComponent from "C:\\Users\\amaan\\encanto-new\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32b4a4e4"]])

export default __exports__